export default "__VITE_ASSET__8tf7HNuO__"